/** Profil menüsünden açılan şifre değiştirme popup'ı. */
import { useTranslation } from 'react-i18next';
import { Dialog } from '@/shared/ui/Dialog';
import { toast } from '@/shared/ui/toastStore';
import { ChangePasswordForm } from './ChangePasswordForm';

export function ChangePasswordDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title={t('auth.changePassword.title')} size="sm">
      <ChangePasswordForm
        idPrefix="pwd-dialog"
        onCancel={() => onOpenChange(false)}
        onSaved={() => {
          onOpenChange(false);
          toast.success(t('auth.changePassword.done'));
        }}
      />
    </Dialog>
  );
}
